// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileBackSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');

  var TileTitleBackSide = require('../Izenda.TileTitleBackSide');
  var TextTileToolbar = require('./Izenda.TextTileToolbar');
  var TinyMCE = require('share/components/controls/TinyMCE/Izenda.TinyMCE');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var localizer = require('share/localization/Izenda.Localizer');

  var TextTileBackSide = React.createClass({

    propTypes: {
      dashboardPart: React.PropTypes.object.isRequired
    },

    render: function () {
      var dashboardPart = this.props.dashboardPart;
      var text = dashboardPart.getBodyText();
      var config = dashboardPart.getBodyConfig();

      return (
        <div className="izenda-DashboardTile-TextTileBackSide">
          <TileTitleBackSide dashboardPart={dashboardPart} />
          <GridLayout className="u_marginTop">
            <GridLayout.Row>
              <GridLayout.Col cols={1}>
                <span>{localizer.getText('DASHBOARD_LABEL_BODY_TEXT')}</span>
              </GridLayout.Col>
              <GridLayout.Col cols={11}>
                <div className='izenda-DashboardTitle-TileTitleBackSide-TinyMCE'>
                  <TextTileToolbar
                    dashboardPart={dashboardPart}
                    config={config}
                    onExecCommand={this.execCommand}
                    onApplyFormat={this.applyFormat}
                    onToggleFormat={this.toggleFormat}
                    onApplyListFormat={this.applyListFormat}
                  />
                  <TinyMCE
                    ref="tinyMce"
                    id='tinyMceId'
                    content={text}
                    onChange={handleContentChange}
                    config={{statusbar: false}}
                    onFormatChange={handleFormatChange}
                  />
                </div>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        </div>
      );

      /**
       * Handle change tiny mce content
       * @param (event) e
       */
      function handleContentChange (e) {
        dashboardPart.bodyContent.text = e.target.getContent();
        dashboardPart.markDirty && dashboardPart.markDirty();
      }

      /**
       * Handle change font format
       * @param {object} value
       * @param {string} state
       */
      function handleFormatChange (value, state) {
        dashboardPart.bodyContent.config[value] = state;
        dashboardPart.markDirty && dashboardPart.markDirty();
      }
    },

    execCommand: function (key, value) {
      this.refs.tinyMce.execCommand(key, value);
    },

    applyFormat: function (key, value) {
      this.refs.tinyMce.applyFormat(key, value);
    },

    toggleFormat: function (value) {
      this.refs.tinyMce.toggleFormat(value);
    },

    applyListFormat: function (key, value) {
      this.refs.tinyMce.applyListFormat(key, value);
    }
  });

  module.exports = TextTileBackSide;

}());


// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/TextTile/Izenda.TextTileBackSide.jsx